import {AbstractResource} from 'vue3-starter/src/typescript/resource/AbstractResource';
import {ResourceParams} from 'vue3-starter/src/typescript/resource/resource';

export default class BriefCurrencyResource extends AbstractResource {
    currencyCode: string;
    constructor(params: ResourceParams) {
        super(params);
        this.currencyCode = params.currencyCode;
    }
}
